import { createRouter, createWebHistory } from "vue-router";

// Rotas
import LandingPage from "@/views/LandingPage.vue";
import DespedidaStatus from "@/views/DespedidaNotFound.vue";
import LoginAdm from "@/components/landingpage/adm/Login.vue";
import Register from "@/views/Restrito.vue";
import Create from "@/components/restrito/Create.vue";
import Postagem from "@/components/homenagem/Postagem.vue";
import Capela from "@/components/homenagem/FrenteCapela.vue";
import EditarDespedida from "@/components/restrito/EditarDespedida.vue";
import ListaPostagens from "@/components/homenagem/ListaPostagens.vue";
import EsqueciSenha from "@/components/landingpage/adm/EsqueciSenha.vue";
import Mensagens from "@/components/restrito/Mensagens.vue";
import PainelGeralMemorial from "@/components/homenagem/PainelMemoria.vue";
import PainelGeralMemorialMensagens from "@/components/homenagem/PainelMemoriaAprovarMensagem.vue";
import EnviarMensagemPainel from "@/components/homenagem/PainelMemoriaEnviarMensagem.vue";
import PainelDespedidas from "@/components/restrito/PainelDespedidas.vue";
import UserProfile from "@/components/restrito/EditarPerfil.vue";
import CriarModerador from "@/components/restrito/CriarModerador.vue";
import CriarColaborador from "@/components/restrito/CriarColaborador.vue";
import AlterarSenha from "@/components/restrito/AlterarSenha.vue";
import ListaPostagensPublicas from "@/components/homenagem/ListaPostagensPublicas.vue";
import TermoUso from "@/components/landingpage/TermoUso.vue";
// import PoliticaPrivacidade from "@/components/landingpage/PoliticaPrivacidade.vue";
const routes = [
  {
    path: "/despedida-status/:status",
    name: "DespedidaStatus",
    component: DespedidaStatus,
    props: true,
  },
  {
    path: "/despedida-nao-encontrada",
    redirect: { name: "DespedidaStatus", params: { status: "not-found" } },
  }, 
  {
    path: "/admin/transmissao/:id",
    name: "Transmissao",
    component: () => import("@/components/restrito/Transmissao.vue"),
  },
  { path: "/", component: LandingPage }, 
  { path: "/termo-uso", component: TermoUso }, 
  // { path: "/politica-privacidade", component: PoliticaPrivacidade }, 
  { path: "/despedida/:id/:codigo?", name: "Postagem", component: Postagem }, 
  { path: "/despedidas/:token", name: "Postagens", component: ListaPostagens }, 
  { path: "/admin/entrar", component: LoginAdm },
  { path: "/admin/entrar-acesso", component: LoginAdm },
  { path: "/forgot-password", component: EsqueciSenha }, 
  { path: "/admin/despedidas", component: Register }, 
  { path: "/admin/criardespedida", component: Create }, 
  { path: "/admin/mensagens/:id", component: Mensagens }, 
  { path: "/admin/editardespedida/:id", component: EditarDespedida }, 
  { path: "/capela/:empresa/:id", component: Capela }, 
  { path: "/painel", component: PainelGeralMemorial }, 
  { path: "/admin/painel-mensagens", component: PainelGeralMemorialMensagens }, 
  { path: "/painel-enviar-mensagem", component: EnviarMensagemPainel }, 
  { path: "/admin/painel-despedidas", component: PainelDespedidas }, 
  { path: "/admin/:tipo/:id", component: UserProfile }, 
  { path: "/admin/criar-moderador/:idDespedida", component: CriarModerador }, 
  { path: "/admin/cadastro-colaborador", component: CriarColaborador }, 
  { path: "/admin/alterar-senha", component: AlterarSenha }, 
  { path: "/lista-postagens/:tipo", component: ListaPostagensPublicas }, 
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
